const enumApp = [
  "employee",
  "app",
  "workLeave",
  "department",
  "position",
  "documentType",
  "documentAgencyIssued",
  "workShift",
  "configQLNS",
  "helpdesk",
  "documentConfig",
  "customer",
  "holiday",
  "branchLocation",
  "parcelType",
  "user",
  "list-permission",
  "vehicle",
  "vehicleType",
  "departmentGroup",
  "reminder",
  "appInPlatformGroup",
];

export default enumApp;
